
import web from "../src/Images/web.jpg";
import app from "../src/Images/mob.jpg";
import software from "../src/Images/soft.jpg";
import android from "../src/Images/and.jpg";
import digital from "../src/Images/markt.jpg";
import data from "../src/Images/data.jpg";

// ********************* course sections data ***************************//


const Cdata = [
    {
        imgsrc:web,
        title: "Front-end Devlopment",
    },
    {
        imgsrc:app,
        title: "MERN Devlopment",
    },
    {
        imgsrc:software,
        title: "Software Devlopment",
    },
    {
        imgsrc:android,
        title: "Android Devlopment",
    },
    {
        imgsrc:digital,
        title: "Data Science",
    },
    {
        imgsrc:data,
        title: "Data Analyse",
    },
];

export default Cdata;